<template>
  <div>
    <PrimaryButton light @click.native="openDialog" shrink>
      Edit
      <v-icon class="ml-3">mdi-pencil</v-icon>
    </PrimaryButton>
    <EditExperienceDialog
      :isOpen="isDialogOpen"
      @close="closeDialog"
      v-if="isDialogOpen"
    />
  </div>
</template>

<script>
import EditExperienceDialog from "@/views/settings/components/dialogs/EditExperienceDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";

export default {
  name: "EditExperienceAction",
  components: { PrimaryButton, EditExperienceDialog },
  data() {
    return {
      isDialogOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isDialogOpen = true;
    },
    closeDialog() {
      this.isDialogOpen = false;
    }
  }
};
</script>

<style scoped></style>
